export default {
  common: {
    account: '帐户'
  },
  views: {
    home: {
      pageTitle: '东京哈利波特制片厂之旅官方',
      welcomeToUse:
        '欢迎使用微信官方小程序\n「东京哈利波特制片厂之旅官方」\n购票&查询资讯',
      redirectButton: '点击跳转微信小程序',
      footnote: '*请用手机默认浏览器打开\n（手机需装微信APP）',
      copyright:
        'All characters and elements © & ™ Warner Bros. Entertainment Inc.\nWB SHIELD: © & ™ WBEI. Publishing Rights © JKR.'
    }
  }
};
